// src/pages/PoliticaPrivacidad.jsx
import React from "react";

const PoliticaPrivacidad = () => {
  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">Política de Privacidad</h1>
      <p className="text-secondary">
        Esta es una versión simplificada de nuestra política de privacidad. 
        Explicamos cómo manejamos los datos básicos que recopilamos para 
        ofrecerte una mejor experiencia.
      </p>

      <h5 className="fw-bold mt-4">1. Datos que recopilamos</h5>
      <p>Información de registro y uso básico de la plataforma.</p>

      <h5 className="fw-bold mt-4">2. Uso de datos</h5>
      <p>
        Los datos se usan únicamente para gestionar tus beneficios, puntos y 
        comunicación con comercios.
      </p>

      <h5 className="fw-bold mt-4">3. Tus derechos</h5>
      <p>Podés solicitar modificación o eliminación de tus datos cuando quieras.</p>
    </div>
  );
};

export default PoliticaPrivacidad;
